import { api } from "../api";
import type { AuditEventItem, PaginatedResponse } from "../../types/domain";

export type AuditLogListParams = {
  skip?: number;
  limit?: number;
  actor_email?: string;
  action_type?: string;
  entity_type?: string;
  success?: boolean;
  date_from?: string;
  date_to?: string;
};

export const auditLogService = {
  list: (params?: AuditLogListParams) => {
    const query = new URLSearchParams();
    Object.entries(params ?? {}).forEach(([key, value]) => {
      if (value !== undefined && value !== "") query.set(key, String(value));
    });
    const qs = query.toString();
    return api.get<PaginatedResponse<AuditEventItem>>(
      `/audit-events${qs ? `?${qs}` : ""}`
    );
  },
};
